module.exports = __webpack_public_path__ + "img/yuanqu.563901c7.png";